export default __webpack_public_path__ + "static/media/SZ01.5217205b.mp3";